import generatePicker from "antd/es/date-picker/generatePicker";
import { format, isValid, parse } from "date-fns";
import { Locale } from "date-fns";
import dateFnsGenerateConfig from "rc-picker/lib/generate/dateFns";

import { useConfigProvider } from "../../ConfigProvider";

import getAntdPickerLocaleConfig from "./getAntdPickerLocaleConfig";

/*
  https://github.com/ant-design/ant-design/issues/47241 
  Date is not correctly modified, pointed place is jumping to the end when removing, 
  can't modify correctly date or time.
*/
let component: null | ReturnType<typeof generatePicker<Date>> = null;
let lastLocale: Locale | null = null;

const useDatePicker = (): ReturnType<typeof generatePicker<Date>> => {
  const { dateFnsLocale } = useConfigProvider();

  if (!component || lastLocale !== dateFnsLocale) {
    component = generatePicker<Date>({
      ...dateFnsGenerateConfig,
      locale: {
        ...getAntdPickerLocaleConfig(dateFnsLocale),
        // The locale name rc-picker passes here is antd's ("ru_RU", "es_ES"), and date-fns has
        // no locale registered under those names, so resolving it by name yields nothing for
        // every locale except en_US, en_GB and pt_BR — typed dates were silently discarded.
        // Use the current date-fns locale instead, which is what getAntdPickerLocaleConfig
        // substitutes for every other method on this object.
        parse: (_locale, text, formats) => {
          const validFormat = formats.find((currentFormat) => {
            const parsedDate = parse(text, currentFormat, new Date(), {
              locale: dateFnsLocale,
            });
            return (
              isValid(parsedDate) &&
              format(parsedDate, currentFormat, { locale: dateFnsLocale }) === text
            );
          });

          if (!validFormat) {
            return null;
          }

          return parse(text, validFormat, new Date(), {
            locale: dateFnsLocale,
          });
        },
      },
    });
    lastLocale = dateFnsLocale;
  }
  return component;
};

export default useDatePicker;
